const d3 = require('d3');

const all_years = [1982, 1984, 1986, 1988, 1990, 1992, 1994, 1996, 1998, 2000, 2002, 2004, 2006, 2008, 2010, 2012, 2014, 2016];

// Default dy, dx
// are for mini maps
const cities_coast = [
  {
    name: 'Austin',
    x: -97.7431,
    y: 30.2672,
    dy: 2,
    dx: 26
  },
  {
    name: 'Houston',
    x: -95.3399792905,
    y: 29.8199743846,
    dy: 15,
    dx: 16,
  },
  {
    name: 'Corpus Christi',
    x: -97.4018947772,
    y: 27.7428143504,
    dx: -20,
    dy: -20
  },{
    name: 'Gulf of',
    x: -94.5,
    y: 27.7,
    textAnchor: 'start',
    dx: -25
  },{
    name: 'Mexico',
    x: -94.5,
    y: 27.35,
    textAnchor: 'start',
    dx: -25
  }
];

const cities = [
  {
    name: 'El Paso',
    x: -106.4850,
    y: 31.7619,
    textAnchor: 'start',
    dx: 10,
    dy: 6
  },
  {
    name: 'Dallas',
    x: -96.7970,
    y: 32.7767
  },
  {
    name: 'Houston',
    x: -95.3399792905,
    y: 29.8199743846
  },
  {
    name: 'Austin',
    x: -97.7427783628,
    y: 30.2669496857,
    dx: 10
  },
  {
    name: 'San Antonio',
    x: -98.5073053404,
    y: 29.4873331899,
    dx: -16
  },
  {
    name: 'Corpus Christi',
    x: -97.4018947772,
    y: 27.7428143504,
    dy: -20
  }
];

// Defaults, full screen
var g_mobile_width = 900;

if (window.innerWidth > g_mobile_width) {
  var g_width_mini = 200;
} else {
  var g_width_mini = 215;
}
var g_width_two = 375;
var g_width_all_texas = g_width_two;
var g_width_three = 325;
var g_width_four = 275;

export const gVars = {
  mobile_width: g_mobile_width,
  // Our maps
  map_key: '#maps-wrapper-key',
  map_vtds: '#maps-wrapper-vtds',
  map_mini: '#maps-wrapper-mini',
  map_redistricting: '#maps-wrapper-redistricting',
  map_farenthold_home: '#maps-wrapper-farenthold-home',
  map_hispanic: '#maps-wrapper-hispanic',
  map_hod: '#maps-wrapper-hod',
  map_hod_zoom: '#maps-wrapper-hod-zoom',
  // Options for the maps
  maps_shapes: 'circle',
  // Width, height for maps
  // Based on how many are on the page
  width_key_map: 150,
  height_key_map: Math.round(150 * 0.97),
  width_mini: g_width_mini,
  height_mini: Math.round(g_width_mini * 0.97),
  width_two: g_width_two,
  height_two: Math.round(g_width_two * 0.93),
  width_three: g_width_three,
  height_three: Math.round(g_width_three * 0.93),
  width_four: g_width_four,
  height_four: Math.round(g_width_four * 0.93),
  width_all_texas: g_width_all_texas,
  height_all_texas: Math.round(g_width_all_texas * 0.93),
  // Map stuff
  district_num: 27,
  c_year: 2012,
  all_years: all_years,
  cities_coast: cities_coast,
  cities: cities,
  locator_circle: {
    x: -96.580811,
    y: 27.95832
  },
  years_dem: [1982, 1984, 1986, 1988, 1990, 1992, 1994, 1996, 1998, 2000, 2002, 2004, 2006, 2008],
  years_rep: [2010, 2012, 2014, 2016]
};

// Add to the global vars
gVars.overlay_maps = [gVars.map_hispanic];
gVars.overlay_map_vtds = [gVars.map_vtds, gVars.map_farenthold_home];
gVars.hod_maps = [gVars.map_hod, gVars.map_hod_zoom];



// WEBPACK FOOTER //
// ./00-global-init.js